// Route constants and utilities for better maintainability
export const ROUTES = {
  HOME: '/',
  ADMIN: {
    LOGIN: '/admin/login',
    DASHBOARD: '/admin',
    PRODUCTS: '/admin/products',
    CATEGORIES: '/admin/categories',
    CONTACTS: '/admin/contacts',
    WORKERS: '/admin/workers',
    SETTINGS: '/admin/settings',
  },
} as const;

export type RouteKeys = keyof typeof ROUTES;

// Utility function to check if a path is an admin route
export const isAdminRoute = (path: string): boolean => {
  return path.startsWith('/admin');
};

// Utility function to get admin route without /admin prefix
export const getAdminPath = (path: string): string => {
  return path.replace('/admin', '') || '/';
};

// Utility function to build admin route
export const buildAdminRoute = (subPath: string): string => {
  return `/admin${subPath.startsWith('/') ? subPath : `/${subPath}`}`;
};